import { Link } from "react-router-dom";
import type { AnimeItem } from "@/mocks/anime";

export default function AnimeCard({ anime }: { anime: AnimeItem }) {
  return (
    <Link
      to={`/anime/${anime.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={anime.cover}
          alt={`${anime.title}最新更新海报`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${
            anime.status === "本周完结" ? "bg-accent-500" : "bg-primary-500"
          }`}
        >
          {anime.status}
        </span>
        <span className="absolute bottom-2 right-2 rounded-md bg-foreground-950/70 px-2 py-1 text-xs font-bold text-background-50">
          {anime.score}分
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950">{anime.title}</h3>
        <p className="text-xs text-foreground-600">{anime.latestEp} · {anime.day} {anime.updateTime}</p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5 pt-1">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
            {anime.category}
          </span>
          <span className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600">
            {anime.views}观看
          </span>
        </div>
      </div>
    </Link>
  );
}